<template>
    <div class="activities">
    <div class="activities__header">
        <h2>So'ngi faolliklar</h2>
    </div>
    
    <div class="activities__box">
        <div class="activities__boxHeader roomListRoom__header">
            <a href="/profile/7/" class="roomListRoom__author">
                <div class="avatar avatar--small">
                    <img src="../assets/images/avatar.svg">
                </div>
                <p>
                    @shohqadam
                    <span>3&nbsp;weeks, 5&nbsp;days ago</span>
                </p>
            </a>

            

        </div>
        <div class="activities__boxContent">
            <p>replied to post “<a href="/room/22/">Js Nuggets</a>”</p>
            <div class="activities__boxRoomContent">dfgdf</div>
        </div>
    </div>
    
    <div class="activities__box">
        <div class="activities__boxHeader roomListRoom__header">
            <a href="/profile/7/" class="roomListRoom__author">
                <div class="avatar avatar--small">
                    <img src="../assets/images/avatar.svg">
                </div>
                <p>
                    @shohqadam
                    <span>3&nbsp;weeks, 5&nbsp;days ago</span>
                </p>
            </a>

            

        </div>
        <div class="activities__boxContent">
            <p>replied to post “<a href="/room/22/">Js Nuggets</a>”</p>
            <div class="activities__boxRoomContent">dsfsdf</div>
        </div>
    </div>
    
    <div class="activities__box">
        <div class="activities__boxHeader roomListRoom__header">
            <a href="/profile/7/" class="roomListRoom__author">
                <div class="avatar avatar--small">
                    <img src="../assets/images/avatar.svg">
                </div>
                <p>
                    @shohqadam
                    <span>3&nbsp;weeks, 5&nbsp;days ago</span>
                </p>
            </a>

            

        </div>
        <div class="activities__boxContent">
            <p>replied to post “<a href="/room/22/">Js Nuggets</a>”</p>
            <div class="activities__boxRoomContent"></div>
        </div>
    </div>
    

</div>
</template>
<script>
export default {
  name: "LatestActions",
};
</script>